import { useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import { baseURL } from "../../utils/misc";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import Preloader from "../common/Preloader";
import { getFullCropName } from "../../utils/helpers";
import PackagingTable from "./PackagingTable";
import CropInfo from "../Crop/CropInfo";

function PackagingListing({ cropId }) {
    
    const { user } = useAuth();
    const [packagingRecords, setPackagingRecords] = useState([]);
    const navigate = useNavigate();
    const [showPreloader, setShowPreloader] = useState(false);
    const [crop, setCrop] = useState();
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState(null);

    const handleEyeIconClick = () => {
      if (crop) {
        setModalData({ crop });
        setShowModal(true);
      } else {
        toast.warn("No crop data available to display.");
      }
    };

    const closeModal = () => {
      setShowModal(false);
      setModalData(null);
    };

    useEffect(() => {
        const fetchCrops = async () => {
            if (!(user && user.user.token)) {
                navigate('/login');
                toast.warn("You seem to have lost your access token. Please try again later.");
                return;
            }
            setShowPreloader(true);
            try {
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${user.user.token}`,
                    }
                };
                const response = await fetch(`${baseURL}/crops/${cropId}`, requestOptions);
                if (!response.ok) {
                    throw new Error('Error fetching crops');
                }
                const data = await response.json();
                setCrop(data);
            } catch (error) {
                toast.error("Error fetching crops.");
                console.error("Error fetching crops:", error);
            } finally {
                setShowPreloader(false);
            }
        };
        fetchCrops();
    }, [user, navigate, cropId]);

    useEffect(() => {
        const fetchPackagingRecords = async () => {
            if (!(user && user.user.token)) {
                navigate('/login');
                toast.warn("You seem to have lost your access token. Please try again later.");
                return;
            }
            setShowPreloader(true);
            try {
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${user.user.token}`,
                    }
                };
                const response = await fetch(`${baseURL}/packagingrecords/crop/${cropId}`, requestOptions);
                if (!response.ok) {
                    throw new Error('Error fetching packaging records');
                }
                const data = await response.json();
                setPackagingRecords(data);
            } catch (error) {
                toast.error("Error fetching packaging records.");
                console.error("Error fetching packaging records:", error);
            } finally {
                setShowPreloader(false);
            }
        };
        fetchPackagingRecords();
    }, [cropId]);

    return (
        <>
            <Preloader show={showPreloader} />
            <div className="main-container">

                <div className="row gutters">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">

                        <div className="card">
                            <div className="card-header">
                                <div className="card-title">List of Packaging Records</div>
                                <div className="mt-3 p-2 parentLabel">
                                    <div className="mt-2 mb-1">
                                        <span>Crop: </span>{getFullCropName(crop)}
                                        <Link to={`/crops/field/${crop && crop.fieldId}`}><span className="float-end"><i className="icon-arrow-left"></i>Go back</span></Link>
                                        <span> {crop && (
                                            <i className="icon-eye"
                                            onClick={handleEyeIconClick}
                                            style={{ cursor: "pointer" }} />)}</span>
                                    </div>
                                </div>
                                <br/>
                                <Link
                                    to={`/packagingrecord/create/?crop=${cropId}`}
                                    className="btn btn-primary float-end"
                                >
                                    <i className="icon-add"></i> Add Packaging Record
                                </Link>
                                
                            </div>
                            <PackagingTable packagingRecords={packagingRecords} allowEdit={true} />
                        </div>
                    </div>
                </div>


                {/* Row start */}

                {/* Row end */}

            </div>
            {showModal && modalData && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="cropInfoModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="cropInfoModalLabel">Crop Information</h5>
                                <button type="button" className="close" onClick={closeModal} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <CropInfo contract={modalData} />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default PackagingListing;